import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import useGlobalName from '@hooks/useGlobalName';
import { ItemCategory as ItemCategoryResponse } from '@models/item/itemCategory';

import useCategoryIcon from './hooks/useCategoryIcon';
import useSelectCategory from './hooks/useSelectCategory';

interface Props {
    itemCategory: ItemCategoryResponse;
    categories: ItemCategoryResponse[];
}

function ItemCategory({
    itemCategory, categories,
}:Props) {
    const { name, nameJa, nameEn } = itemCategory;
    const categoryName = useGlobalName({ nameEn, nameJa, name });
    const { handleSelectCategory, isSelected } = useSelectCategory(itemCategory, categories);
    const icon = useCategoryIcon(itemCategory);
    return (
        <Container isSelected={isSelected}
            onClick={handleSelectCategory} >
            {icon}
            <Text size='lg'
                fontWeight={isSelected ? 'bold' : 'regular'}
                color={isSelected ? colors.buttonText : colors.textSecondary}>
                {categoryName}
            </Text>
        </Container>
    );
}

const Container = styled.button<{
    isSelected: boolean;
}>`
    align-items: center;
    column-gap: 8px;
    display: flex;
    padding:  8px;
    white-space: nowrap;
    background-color: ${({ isSelected }) => (isSelected
        ? 'var(--color-primary)' : 'var(--color-gray1)')};
    border-radius: 12px;
    height: 40px;
    transition: background-color 100ms;
`;

const IconImage = styled(Image)`
    border-radius: 24px;
    object-fit: cover;
`;

export default ItemCategory;
